angular.module('avant.customer_applications.services', ['ngResource']);
require('./ApplicationService.coffee');
require('./HardSecuredService.coffee');
require('./HelperService.coffee');
require('./RandomizationService.js');
